// extracted by mini-css-extract-plugin
export default {"container":"PriceInput_container__ZY3H+","price":"PriceInput_price__oVmNx"};